import styled from "styled-components";

const CedeMemberContainer = styled.div`

`;

export default CedeMemberContainer;